import { env } from 'src/config/env';

export const convertCoreDocuments = (documents) => (
  documents.map((d) => {
    const url = `${env.CORE_BASE_URL}${d.path}`;
    d.url = url;            // eslint-disable-line
    d.pdf_url = url;        // eslint-disable-line
    d.thumbnail_url = url;  // eslint-disable-line
    d.title = d.filename;   // eslint-disable-line
    return d;
  })
);
